<template>
  <div :style="{direction:$t('direction')}">
    <div class="dashboard">
      <Sidebar />
      <div class="content">
        <Header />
        <div class="dashboard-content">
          <HelperNav />
          <div class="dashboard-wrapper">
            
            <div class="ar-card">
              <div class="ar-card-header">
                <div class="ar-card-title">
                  برداشت 
                </div>
                <span></span>
              </div>
              <div class="ar-card-body">

                <template v-if="step === 1">
                  <div class="text-primary-dark m-auto" style="max-width:400px;">
                    
                    <div class="ar-form-group">
                      <label>برداشت به صورت</label>
                      <select class="ar-form-control text-center" v-model="withdraw.received_currency">
                        <option :value="null" disabled hidden>انتخاب ارز برداشتی</option>
                        <option value="IRR">تومان</option>
                        <option value="USDT">تتر</option>
                      </select>
                      <div v-if="errors.paid_currency" class="ar-form-text">
                        <small>انتخاب ارز برداشتی الزامی است.</small>
                      </div>
                    </div>

                    <template v-if="withdraw.received_currency">
                      <h4 class="text-center pt-3" v-if="withdraw.received_currency === 'IRR'">موجودی تومانی شما:  {{ formatPrice(userData.user_detail.cash) }} </h4>
                      <h4 class="text-center pt-3" v-if="withdraw.received_currency === 'USDT'">مقدار تتر های شما: {{ userData.user_detail.tether }} </h4>
                    </template>

                    <div class="ar-form-group">
                      <label v-if="withdraw.received_currency === 'IRR'">مبلغ درخواستی</label>
                      <label v-if="withdraw.received_currency === 'USDT'">میزان درخواستی</label>
                      <input onclick="this.select()" class="ar-form-control text-center" type="number" @keypress="just_float($event)" v-model="withdraw.received_amount">
                      <div v-if="errors.received_amount" class="ar-form-text">
                        <small>{{ errors.received_amount[0] }}</small>
                      </div>

                      <div v-if="withdraw.received_amount && withdraw.received_currency === 'IRR'">
                        <small>معادل {{ formatPrice(withdraw.received_amount) }} تومان</small>
                      </div>
                    </div>

                    <template v-if="withdraw.received_currency === 'IRR'">

                      <div class="ar-form-group pt-3">
                        <div class="text-center py-1">
                          <add-bank-account>
                            <button class="ar-btn size-xs primary round">افزودن کارت بانکی <i class="mdi mdi-plus"></i></button>
                          </add-bank-account>
                        </div>
                        <select class="ar-form-control text-center" v-model="withdraw.bank_account_id">
                          <option :value="null" disabled hidden>انتخاب کارت بانکی</option>
                          <option v-for="(item , key) in confirmed_bank_accounts" :key="key" :value="item.id">{{ item.card_number }}</option>
                        </select>
                        <div v-if="errors.bank_account_id" class="ar-form-text">
                          <small>انتخاب کارت بانکی الزامی است.</small>
                        </div>
                      </div>
                      
                      <div class="text-center">
                        <button v-if="!withdraw.received_amount || !withdraw.bank_account_id" class="ar-btn size-md round primary disabled">ثبت درخواست</button>
                        <button v-else class="ar-btn size-md round primary" @click="submitWithdrawReq()">ثبت درخواست</button>
                      </div>

                    </template>

                    <template v-if="withdraw.received_currency === 'USDT'">
                        
                        <div class="ar-form-group">
                          <div class="text-center py-1">
                            <add-wallet>
                              <button class="ar-btn size-xs primary round">افزودن ولت <i class="mdi mdi-plus"></i></button>
                            </add-wallet>
                          </div>
                          <select class="ar-form-control text-center" v-model="withdraw.wallet_id">
                            <option :value="null" disabled hidden>لطفا ولت خود را انتخاب نمایید</option>
                            <option v-for="(item , key) in state_wallets" :key="key" :value="item.id" class=" font-en">{{ item.address }}</option>
                          </select>
                          <div v-if="errors.wallet_id" class="ar-form-text">
                            <small>انتخاب ولت الزامی است</small>
                          </div>
                        </div>
                      
                      <div class="text-center">
                        <button v-if="!withdraw.received_amount || !withdraw.wallet_id" class="ar-btn size-md round primary disabled">ثبت</button>
                        <button v-else class="ar-btn size-md round primary" @click="submitWithdrawReq()">ثبت درخواست</button>
                      </div>
                      
                    </template>

                  </div>
                </template>

                <template v-if="step === 2">
                  
                  <div class="mdi mdi-close font-3" @click="step = 1"></div>
                  <div class="text-primary-dark pb-3 text-center">
                    <div>ثبت درخواست برداشت با موفقیت انجام شد.</div>

                    <div>مقدار برداشتی شما بعد از تایید درخواست  به حساب شما واریز می گردد.</div>
                  </div>

                </template>

              </div>
            </div>
            
            <div v-if="step == 1" class="ar-card mt-3">
              <div class="ar-card-header">
                <div class="ar-card-title">
                  تاریخچه برداشت ها 
                </div>
                <span></span>
              </div>
              <div class="ar-card-body">

                <div v-if="!Object.keys(histories).length" class="p-4 text-center">هنوز درخواستی ایجاد نشده است.</div>

                <div class="table-responsive">
                  <table class="table ar-table">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>مقدار برداشتی</th>
                        <th>وضعیت درخواست</th>
                        <th>زمان</th>
                        <th>جزئیات</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item , key) in histories" :key="key">
                        <td>{{ key+1 }}</td>
                        <td>
                          <template v-if="item.received_currency == 'USDT'">
                            {{ item.received_amount }} تتر 
                          </template>
                          <template v-if="item.received_currency == 'IRR'">
                            {{formatPrice(item.received_amount)}} تومان
                          </template>
                        </td>
                        <td>
                          <span class="text-warning" v-if="item.status == 0">در حال بررسی</span>
                          <span class="text-success" v-if="item.status == 1">تایید شده</span>
                          <span class="text-danger" v-if="item.status == 2">رد شده</span>
                        </td>
                        <td>
                          {{item.registered_at}}
                        </td>
                        <td>
                          <span :class="[
                              (item.status == 0 ? 'text-warning' : ''),
                              (item.status == 1 ? 'text-success' : ''),
                              (item.status == 2 ? 'text-danger' : '')
                            ]"
                          >
                            <router-link :to="{name:'ExchangeDetails' , params:{id:item.uuid}}">
                              <i class="mdi mdi-information-outline"></i>
                            </router-link>
                          </span>

                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

              </div>

            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Sidebar from './partials/Sidebar'
import Header from './partials/Header'
import {TheMask} from 'vue-the-mask'
import vSelect from 'vue-select'
import {io} from 'socket.io-client';
import AddWallet from '../../components/AddWallet.vue'
import HelperNav from './partials/HelperNav'
import AddBankAccount from '../../components/AddBankAccount.vue'
export default {
  name: 'Withdraw',
  components:{
    HelperNav,
    AddWallet,
    AddBankAccount,
    Sidebar,
    Header,
    TheMask,
    vSelect
  },
  data : () => ({
    withdraw:{
      received_currency:null,
      bank_account_id:null,
      wallet_id:null
    },
    errors:{},
    step:1,

    success_harvest:false,
    error_text:null,
    socket : null,
    histories : [],
  }),
  computed:{
    confirmed_bank_accounts()
    {
      const confirmed = this.state_bank_accounts.filter(bank_account => {
        return bank_account.status == 1;
      });

      return confirmed;
    }
  },
  watch:{
    state_wallets(){
      if(this.state_wallets.length){
        this.withdraw.wallet_id = this.state_wallets[0].id
      }
    }
  },
  methods:{
    submitWithdrawReq (){
      this.errors = {}
      this.activeLoading(true)
      const api_token = this.getToken()

      this.$axios.post(`submitWithdrawReq` , this.withdraw,
      {
        headers: {
          'api_token':api_token
        }
      })
      .then( () => {
        this.activeLoading(false)
        this.errors = {}
        this.withdraw = {
          received_currency:null,
          bank_account_id:null,
          wallet_id:null
        }
        this.socket.emit('admin_notification');

        this.step = 2
        location.reload()
      })
      .catch(err => {
        const error = err.response.data;
        if(error.message){
          this.$notify({
            group: 'foo',
            type: 'error',
            duration: 5000,
            text: error.message
          });
        }else{
          this.errors = error.errors
        }
        this.activeLoading(false)
      });

    },
    getHistories(){
      this.activeLoading(true)
      const api_token = this.getToken()
      
      this.$axios.post(`exchangesHistory`,{type:'withdraw'},
      {
        headers: {
          'api_token':api_token
        }
      })
      .then(res => {
        this.histories = res.data.data
        this.activeLoading(false)
      })
      .catch(err => {
        this.activeLoading(false)
      });

    },
  },
  mounted() {
    this.activeLoading(false)
    this.socket = io(this.socketUrl);
    this.checkAuth()
    this.checkConfirmed()

    this.getHistories()
  }
}
</script>